import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: '30px',
    boxSizing: 'border-box',
    maxHeight: '90vh',
    borderRadius: '10px',
  },
  downloadIcon: {
    cursor: 'pointer',
    '& > path': {
      fill: `${theme.palette.text.primary} !important`,
    },
  }
}));

export default useStyles;
